export const LOGIN_TO_BILLING_HISTORY_URL =
  'https://users.wix.com/signin?postLogin=' +
  encodeURIComponent('https://manage.wix.com/studio/billing-history');

export enum Brands {
  WIX = 'wix',
  EDITOR_X = 'editorx',
}

export enum Locales {
  en = 'en',
  de = 'de',
  es = 'es',
  fr = 'fr',
  it = 'it',
  nl = 'nl',
  no = 'no',
  pl = 'pl',
  pt = 'pt',
  ru = 'ru',
  sv = 'sv',
  ja = 'ja',
  cs = 'cs',
  ko = 'ko',
  tr = 'tr',
  da = 'da',
  hi = 'hi',
  zh = 'zh',
  th = 'th',
  uk = 'uk',
  vi = 'vi',
  id = 'id',
}

export const languages = [
  { id: Locales.en, value: 'English' },
  { id: Locales.de, value: 'Deutsch' },
  { id: Locales.es, value: 'Español' },
  { id: Locales.fr, value: 'Français' },
  { id: Locales.it, value: 'Italiano' },
  { id: Locales.nl, value: 'Nederlands' },
  { id: Locales.no, value: 'Norsk' },
  { id: Locales.pl, value: 'Polski' },
  { id: Locales.pt, value: 'Português' },
  { id: Locales.ru, value: 'Русский' },
  { id: Locales.sv, value: 'Svenska' },
  { id: Locales.ja, value: '日本語' },
  { id: Locales.cs, value: 'Čeština' },
  { id: Locales.ko, value: '한국어' },
  { id: Locales.tr, value: 'Türkçe' },
  { id: Locales.da, value: 'Dansk' },
  { id: Locales.hi, value: 'हिन्दी' },
  { id: Locales.zh, value: 'Chinese' },
  { id: Locales.th, value: 'Thai' },
  { id: Locales.uk, value: 'Українська' },
  { id: Locales.vi, value: 'Tiếng Việt' },
  { id: Locales.id, value: 'Bahasa Indonesia' },
];
